module.exports = __webpack_public_path__ + "static/shipper-1-879dd42717e948c98c7369cf3702171c.png";